
  <template>
    <svg
      xmlns="http://www.w3.org/2000/svg" :width="size" :height="size" viewBox="0 0 24 24" aria-hidden="true" :stroke="color" fill="none" stroke-width="1" stroke-linecap="round" stroke-linejoin="round"
    >
      <line y1="-0.5" x2="18" y2="-0.5" transform="matrix(-4.37114e-08 1 1 4.37114e-08 21 3)"></line><path opacity="0.5" d="M17 3.5H15M13 3.5H11M9 3.5H7M5 3.5H3V5.38889M3 7.27778V9.16667M3 11.0556V12.9444M3 14.8333V16.7222M3 18.6111V20.5H5M7 20.5H8H9M11 20.5H13M15 20.5H17"></path>
    </svg>
  </template>
  <script>
    import { defineComponent } from "vue";

    export default defineComponent({
      name: "OiBorderright",
      props: {
        size: {
          type: Number,
          default: 16
        },
        color: {
          type: String,
          default: "currentColor"
        }
      }
    });
  </script>
